import React, { useCallback } from 'react';
import { IconVideoMissedCallHoc, IconAudioMissedCallHoc, IconVideoOutgoingCallHoc, IconAudioOutgoingCallHoc, IconVideoIncommingCallHoc, IconAudioIncommingCallHoc, IconVideocallHoc, IconAudiocallHoc } from '../../../assets/images';
import { formatCallLogDate, formatCallLogTime, durationCallLog, getHighlightedText } from '../../../Helpers/Utility';
import { getFromLocalStorageAndDecrypt } from '../../../Helpers/Chat/webChatEncryptDecrypt';
import ProfileImage from '../../Common/ProfileImage';
import { useSelector } from 'react-redux';
import { formatUserIdToJid, getLocalUserDetails } from '../../../Helpers/Chat/User';
import { handleParticipantList } from '../../../Helpers/Chat/ChatHelper';
import Modal from '../../WebChat/Common/Modal';
import BlockPopUp from '../../WebChat/ConversationSection/PopUp/BlockPopUp';
import { UNBLOCK_CONTACT_TYPE } from '../../../Helpers/Chat/Constant';
import SDK from '../../../SDK';
import { updateBlockedContactAction } from '../../WebChat/ConversationSection/PopUp/BlockAction';
import { toast } from 'react-toastify';

const CallLogView = (props = {}) => {
    const stateData = useSelector((state) => state)
    const { rosterData, blockedContact } = stateData
    let { displayName, image, searchterm, callLog, emailId,initialName="", isAdminBlocked, isDeletedUser, userId, userBlocked } = props;
    const [showModal, setshowModal] = React.useState(false);
    const [blockId, setBlockId] = React.useState(null);
    const [nameToDisplay, setNameToDisplay] = React.useState(null);
    const onClick = useCallback(() => {
        if(isAdminBlocked || isDeletedUser || !canSendMessage() || userBlocked) return;
        props.makeCall(callLog);
    })

    if (displayName && searchterm !== "" && !displayName.toLowerCase().includes(searchterm)) {
        return null;
    }
    const getGroupMembers = (participants) => {
        const { rosterData: { data: totalContactList = [] } = {} } = rosterData
        return participants && handleParticipantList(participants, totalContactList) || []
    }

    const popUpToggleAction = (userIds, nameToDisplays) => {
        setshowModal(!showModal);
        setBlockId(userIds ? userIds : null)
        setNameToDisplay(nameToDisplays ? nameToDisplays : null)
    };

    const dispatchAction = async () => {
        setshowModal(!showModal);
        const res = await SDK.unblockUser(blockId);
        console.log("SDK res",res)
        if (res && res.statusCode === 200) {
            updateBlockedContactAction(blockId, UNBLOCK_CONTACT_TYPE);
            toast.success(`${nameToDisplay || 'User'} has been Unblocked`);            
        }
    }

    const canSendMessage = () => {
        let groupMemberDetails = [];
        let vcardData = getLocalUserDetails();
        let fromUser = vcardData.fromUser;
        if (callLog.callMode === 'onetoone' || callLog.groupId === "" || callLog.groupId === null) {
            return true;
        }
        else {
            const { groupsMemberParticipantsListData: { groupParticipants = {} } = {} } = stateData || {}
            let participants = groupParticipants[callLog.groupId];
            groupMemberDetails = getGroupMembers(participants)
            if (!groupMemberDetails) return true;
            return groupMemberDetails.find((profile) =>
                fromUser === profile.userId
            );
        }
    }

    const token = getFromLocalStorageAndDecrypt('token');
    let date = formatCallLogDate(callLog.callTime / 1000);
    let time = formatCallLogTime(callLog.callTime);
    let durationText = "";
    let showDuration = false;
    if (callLog.startTime && callLog.endTime) {
        durationText = durationCallLog(callLog.startTime, callLog.endTime);
        showDuration = true;
    }

    let callState = callLog.callState;
    let callStateView = "";
    if (callState === 0) {
        callStateView = props.callLog.callType === "video" ? <IconVideoMissedCallHoc viewBox="0 0 15 15"/> : <IconAudioMissedCallHoc  viewBox="0 0 15 15"/>;
    } else if (callState === 1) {
        callStateView = props.callLog.callType === "video" ? <IconVideoOutgoingCallHoc viewBox="0 0 15 15"/> : <IconAudioOutgoingCallHoc viewBox="0 0 15 15"/> ;
    } else {
        callStateView = props.callLog.callType === "video" ? <IconVideoIncommingCallHoc viewBox="0 0 15 15"/> : <IconAudioIncommingCallHoc viewBox="0 0 15 15"/> ;
    }

    let blockedContactArr = blockedContact.data;
    const jid = formatUserIdToJid(userId);
    const isBlocked = blockedContactArr.indexOf(jid) > -1;

    return <li className={`chat-list-li ${(isAdminBlocked || isDeletedUser || userBlocked) ? "pointer-default-all" : ""}`} onClick={ (!isBlocked) ? onClick : null}>
        <ProfileImage
            chatType={callLog.callMode === "onetoone" ? 'chat' : 'groupchat'}
            userToken={token}
            imageToken={isAdminBlocked ? "" : image}
            emailId={emailId}
            name={initialName}
            userId={userId}
        />
        <div className="recentchats">
            <div className="callInfo">
                <div className="recent-username-block">
                    <div className="recent-username">
                        <div className="username">
                            <h3 title={displayName}>
                                {searchterm ? getHighlightedText(displayName, searchterm) : displayName}
                            </h3>
                        </div>
                    </div>
                </div>
                <div className="CallStatus">
                    <i>
                        {callStateView}
                    </i>
                    <div className="callOn">
                        <span className="callOn">{date},</span> <span className="callTime">
                            {time}
                        </span></div>
                </div>
            </div>
            { isBlocked && callLog.callMode === "onetoone" ?
            <div className='callAction'>            
                <span
                    className="Unblock"
                    data-jest-id={"jestpopUpToggleAction"}
                    onClick={() => { popUpToggleAction(jid, displayName) }}
                >
                    Unblock
                </span>
            </div>
            :
            <div className="callAction">
                {showDuration &&
                    <span className="callDuration" >{durationText}</span>}
                {canSendMessage() && <i className="callType">
                    {props.callLog.callType === "video" ? <IconVideocallHoc viewBox="0 0 16.358 10.6"/> : <IconAudiocallHoc viewBox="0 0 15.562 15.51"/>}
                </i>}
            </div>
            }
            {showModal && <Modal containerId='container'>
                <BlockPopUp
                    popUpToggleAction={popUpToggleAction}
                    dispatchAction={dispatchAction}
                    headerLabel={<>{'Unblock'} {displayName} ?</>}
                    closeLabel={'Cancel'}
                    actionLabel={'Unblock'}
                    infoLabel={'On unblocking, this contact will be able to call you or send messages to you.'}
                />
            </Modal>}
        </div>
    </li>
}

export default CallLogView;
